import {SUBMITTAL} from "../../../services";
import {FileController} from "../../Boilerplate/FileController";

const docKey = ['match', 'params', 'id'];
const subDocKey = ['match', 'params', 'submittalId'];
const indexType = 'submittal';
const topLevelName = 'Submittal';

export const SubmittalFiles = FileController(SUBMITTAL, indexType, docKey, subDocKey, topLevelName);



// WEBPACK FOOTER //
// ./src/components/Projects/Submittals/SubmittalFiles.js